<template>
    <v-dialog :value="modal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <div class="align-v-center cover-bg">
          <v-container grid-list-md text-xs-center>
            <v-layout align-center justify-center row>
              <v-flex sm12 md12>
                <v-card class="elevation-12 pb-4">
                   <offset-heading 
                   titleClass="mb-2 headline font-weight-bold"
                   title="ACCOUNTS" 
                   subtitle="Select the account that you would like to access">
                     <v-btn
                      slot="action"
                      @click="logout()"
                      fab 
                      color="white"
                      :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
                    >
                      <v-icon dark class="primary--text">fas fa-sign-out-alt</v-icon>
                    </v-btn>
                   </offset-heading>
                  <div class="px-4 mx-1 mt-7 pt-7" v-if="userAcounts.length == 0">
                    <p>Sorry you dont have any associated business. Please contact support.</p>
                  </div>
                   <div class="px-4 mx-1 mt-7 pt-7" v-else>
                     <v-layout row wrap justify-space-between>
                        <v-flex px-4 sm12 xs12 md6 lg6 v-bind:key="index" v-for="(account, index) in userAcounts">
                          <v-card hover  class="elevation-12 mb-4 pointer account-list" v-on:click.prevent="setActiveBusiness(account.id)">
                           <div class="c-layout">
                             <div class="cl-flex6">
                                <div class="min-h-80 v-center bg-grey">
                                  <img src="../assets/images/uno-logo.png" class="account-logo"/>
                                </div>
                             </div>
                             <div class="cl-flex6">
                                 <div class="min-h-80 section-excerpt v-center">
                                    <h2 class="font-weight-bold title">{{ account.name }}</h2>
                                 </div>
                             </div>
                           </div>
                          </v-card>
                        </v-flex>
                      </v-layout>
                   </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

</template>
<script>
import AuthApi from '@/components/Controllers/AuthApis';
import Env from '@/env';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    modal() {
      if (this.$store.getters.getLoggedInStep === 'at_chooseAccount') {
        return true;
      }
      return false;
    },
    userAcounts() {
      return this.$store.getters.getLoggedInUserAccounts;
    },
  },
  methods: {
     /**
     * Clear user storage and throw back to login screen
     */
    logout() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/users/logout`;
      AuthApi.postApi(url)
        .then((response) => {
          // On successful logout
          this.$store.dispatch('SET_USER_DATA_EMPTY', '');
          this.$router.push({ name: 'Login' });
          this.snackbar({
            text: response.data.msg,
            timeout: 5000,
            open: true,
          });
          this.spinner(false);
        })
        .catch((err) => {
          this.snackbar({
            text: 'Error occured, please try again later.',
            timeout: 5000,
            open: true,
          });
          this.spinner(false);
        });
    },
    setActiveBusiness(id) {
      this.spinner(true);
      AuthApi.setActiveBusiness(id)
      .then((res) => {
        if (res) {
          this.getBusinessBranding();
          this.spinner(false);
          this.snackbar({
            text: 'Successfully logged in.',
            timeout: 4000,
            open: true,
          });
          this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_completed');
          // Push to home
          this.$router.push({ name: 'Applications' });
        } else {
          this.spinner(false);
          this.snackbar({
            text: 'Please try again later',
            timeout: 4000,
            open: true,
          });
        }
      });
    },

    /**
     * Get selected business branding
     */
    getBusinessBranding() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}`;
      AuthApi.getApi(url)
        .then((res) => {
          if(res.data.payload.branding && res.data.payload.branding.brand_colors){
            this.$vuetify.theme.themes.light.primary = res.data.payload.branding.brand_colors.primary;
            this.$vuetify.theme.themes.light.secondary = res.data.payload.branding.brand_colors.secondary;
            this.$vuetify.theme.themes.light.accent =  res.data.payload.branding.brand_colors.accent;
          }
          this.$store.dispatch('SET_USER_SELECTED_ACCOUNT_BRANDING', res.data.payload.branding);  
        })
        .catch(err => {
          console.log('Cannot fetch branding.')
        })
    },

    ...mapActions({
      setRoles: 'roles/listAction',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

